## `components/LoadingState.vue`
<template>
    <div class="enhanced-loading-container">
        <div class="loading-content">
            <div class="loading-header">
                <h3>{{ message }}</h3>
                <div class="loading-animation">
                    <div class="dot" />
                    <div class="dot" />
                    <div class="dot" />
                </div>
            </div>
            <div class="progress-section">
                <div class="progress-bar">
                    <div class="progress-fill" :style="{ width: progress + '%' }" />
                    <div class="progress-shimmer" />
                </div>
                <span class="progress-text">{{ Math.round(progress) }}% Complete</span>
            </div>
            <div class="loading-steps">
                <div v-for="(s, idx) in steps" :key="idx" class="loading-step"
                    :class="{ completed: idx < currentStep, active: idx === currentStep, pending: idx > currentStep }">
                    <div class="step-indicator">
                        <i v-if="idx < currentStep" class="fas fa-check"></i>
                        <div v-else-if="idx === currentStep" class="spinner"></div>
                        <span v-else class="step-num">{{ idx + 1 }}</span>
                    </div>
                    <span class="step-text">{{ s }}</span>
                </div>
            </div>
            <div v-if="showMinorTip" class="loading-tips">
                <div class="tip-card">
                    <i class="fas fa-info-circle" />
                    <div class="tip-content">
                        <strong>Processing with Minor Requirements</strong>
                        <p>Merging degree and minor requirements can take extra time.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
defineProps<{ message: string; progress: number; steps: string[]; currentStep: number; showMinorTip?: boolean }>();
</script>